const CREDIT_CARDS_BY_AGE = [
  "https://halvacard.ru/order/credit-card/s-18-i-let/",
  "https://halvacard.ru/order/credit-card/s-19-i-let/",
  "https://halvacard.ru/order/credit-card/s-20-let/",
  "https://halvacard.ru/order/credit-card/s-21-goda/",
]

const CREDIT_CARDS_ACCORDING_TO_THE_TERMS = [
  "https://halvacard.ru/order/credit-card/bez-kreditnoy-istorii/",
  "https://halvacard.ru/order/credit-card/bez-oficialnogo-trudoustrojstva/",
  "https://halvacard.ru/order/credit-card/bez-otkaza/",
  "https://halvacard.ru/order/credit-card/bez-pasporta/",
  "https://halvacard.ru/order/credit-card/bez-podtverzhdeniya-dohoda/",
  "https://halvacard.ru/order/credit-card/bez-poseshcheniya-banka/",
  "https://halvacard.ru/order/credit-card/bezrabotnym/",
  "https://halvacard.ru/order/credit-card/bezrabotnym-bez-otkaza/",
  "https://halvacard.ru/order/credit-card/bezrabotnym-s-18-let/",
  "https://halvacard.ru/order/credit-card/ekspress/",
  "https://halvacard.ru/order/credit-card/kreditnie-karti-s-keshbekom/",
  "https://halvacard.ru/order/credit-card/kreditnie-karti-so-snyatiem-nalichnih-bez-protsentov/",
  "https://halvacard.ru/order/credit-card/mir/",
  "https://halvacard.ru/order/credit-card/momentalnaya/",
  "https://halvacard.ru/order/credit-card/momentalnaya/",
  "https://halvacard.ru/order/credit-card/online-zayavka/",
  "https://halvacard.ru/order/credit-card/po-dvum-dokumentam/",
  "https://halvacard.ru/order/credit-card/pod-zalog-nedvizhimosti/",
  "https://halvacard.ru/order/credit-card/po-pasportu/",
  "https://halvacard.ru/order/credit-card/s-besplatnym-obsluzhivaniem/",
  "https://halvacard.ru/order/credit-card/s-bonysami/",
  "https://halvacard.ru/order/credit-card/s-dostavkoi-na-dom/",
  "https://halvacard.ru/order/credit-card/s-dostavkoj-po-pochte/",
  "https://halvacard.ru/order/credit-card/s-plohoj-kreditnoj-istoriej/",
  "https://halvacard.ru/order/credit-card/s-prosrochkami-u-zaemshchika/",
  "https://halvacard.ru/order/credit-card/srochnaya/",
  "https://halvacard.ru/order/credit-card/s-vremennoi-registracie",
  "https://halvacard.ru/order/credit-card/s-plohoy-kreditnoy-istoriey-bez-otkaza/",
]

const CREDIT_CARDS_VIRTUAL_CARDS = [
  "https://halvacard.ru/order/credit-card/virtualnaya/",
  "https://halvacard.ru/order/credit-card/virtualnaja-mir/",
  "https://halvacard.ru/order/credit-card/virtualnye-bez-otkaza/",
  "https://halvacard.ru/order/credit-card/virtualnaja-momentalnaya/",
  "https://halvacard.ru/order/credit-card/virtualnaja-s-18-let/",
  "https://halvacard.ru/order/credit-card/virtualnaja-bezrabotnym/",
  "https://halvacard.ru/order/credit-card/virtualnaja-so-snjatiem-nalichnyh/",
  "https://halvacard.ru/order/credit-card/virtualnaja-dly-pokupok/",
  "https://halvacard.ru/order/credit-card/virtualnaja-s-plokhoy-kreditnoy-istoriey/",
]

const CREDIT_CARDS_BY_TARGET = [
  "https://halvacard.ru/order/credit-card/dlya-pensionerov/",
  "https://halvacard.ru/order/credit-card/dlya-pokupok/",
  "https://halvacard.ru/order/credit-card/dlya-studentov/",
  "https://halvacard.ru/order/credit-card/s-rassrochkoj/",
]

const CREDIT_CARDS_BY_PERIOD = [
  "https://halvacard.ru/order/credit-card/s-besprocentnym-periodom-50-dnej/",
  "https://halvacard.ru/order/credit-card/bez-procentov-100-dney/",
  "https://halvacard.ru/order/credit-card/s-besprocentnym-periodom-110-dnej/",
  "https://halvacard.ru/order/credit-card/s-besprocentnym-periodom-120-dnej/",
  "https://halvacard.ru/order/credit-card/bez-procentov-145-dney/",
  "https://halvacard.ru/order/credit-card/s-besprocentnym-periodom-180-dnej/",
  "https://halvacard.ru/order/credit-card/s-besprocentnym-periodom-god/",
  "https://halvacard.ru/order/credit-card/s-besprocentnym-periodom-200-dnej/",
]

const CREDIT_CARDS_BY_SUM = [
  "https://halvacard.ru/order/credit-card/na-5000-rubley/",
  "https://halvacard.ru/order/credit-card/do-10000-rublej/",
  "https://halvacard.ru/order/credit-card/do-15000-rublej/",
  "https://halvacard.ru/order/credit-card/do-20000-rublej/",
  "https://halvacard.ru/order/credit-card/do-30000-rublej/",
  "https://halvacard.ru/order/credit-card/do-50000-rublej/",
  "https://halvacard.ru/order/credit-card/do-100000-rublej/",
  "https://halvacard.ru/order/credit-card/do-150000-rublej/",
  "https://halvacard.ru/order/credit-card/do-200000-rublej/",
  "https://halvacard.ru/order/credit-card/do-300000-rublej/",
  "https://halvacard.ru/order/credit-card/do-500000-rublej/",
]

const CREDIT_CARDS_IN_OTHERS_CITY = [
  "https://halvacard.ru/order/credit-card/city-chelyabinsk/",
  "https://halvacard.ru/order/credit-card/city-ekaterinburg/",
  "https://halvacard.ru/order/credit-card/city-irkutsk/",
  "https://halvacard.ru/order/credit-card/city-kaliningrad/",
  "https://halvacard.ru/order/credit-card/city-kazan/",
  "https://halvacard.ru/order/credit-card/city-krasnojarsk/",
  "https://halvacard.ru/order/credit-card/city-krasnodar/",
  "https://halvacard.ru/order/credit-card/city-moskva/",
  "https://halvacard.ru/order/credit-card/city-novosibirsk/",
  "https://halvacard.ru/order/credit-card/city-omsk/",
  "https://halvacard.ru/order/credit-card/city-orenburg/",
  "https://halvacard.ru/order/credit-card/city-perm/",
  "https://halvacard.ru/order/credit-card/city-samara/",
  "https://halvacard.ru/order/credit-card/city-sankt-peterburg/",
  "https://halvacard.ru/order/credit-card/city-saratov/",
  "https://halvacard.ru/order/credit-card/city-tyumen/",
  "https://halvacard.ru/order/credit-card/city-ufa/",
  "https://halvacard.ru/order/credit-card/city-volgograd/",
  "https://halvacard.ru/order/credit-card/city-voronez/",
  "https://halvacard.ru/order/credit-card/city-yaroslavl/",
  "https://halvacard.ru/order/credit-card/city-nizhnij-novgorod/",
]

const map = new Map<string[], (url: string) => unknown>([
  [
    CREDIT_CARDS_BY_AGE,
    (url) => ({
      "@context": "https://schema.org",
      "@type": "QAPage",
      mainEntity: {
        "@type": "Question",
        name: "В чём преимущества карты Халва перед обычной кредитной картой?",
        url,
        answerCount: 1,
        acceptedAnswer: {
          "@type": "Answer",
          text: "🆓 Бесплатный выпуск и обслуживание. 💸 Кэшбэк до 10% с подпиской «Халва.Десятка».",
          upvoteCount: 40,
        },
      },
    }),
  ],
  [
    CREDIT_CARDS_ACCORDING_TO_THE_TERMS,
    (url) => ({
      "@context": "https://schema.org",
      "@type": "QAPage",
      mainEntity: {
        "@type": "Question",
        name: "Почему условия карты Халва выгоднее кредитной карты?",
        url,
        answerCount: 1,
        acceptedAnswer: {
          "@type": "Answer",
          text: "⏳ Рассрочка до 10 месяцев без процентов. 🆓 Не платите за выпуск и обслуживание карты — всё бесплатно!",
          upvoteCount: 55,
        },
      },
    }),
  ],
  [
    CREDIT_CARDS_VIRTUAL_CARDS,
    (url) => ({
      "@context": "https://schema.org",
      "@type": "QAPage",
      mainEntity: {
        "@type": "Question",
        name: "Чем карта Халва лучше виртуальной кредитной карты?",
        url,
        answerCount: 1,
        acceptedAnswer: {
          "@type": "Answer",
          text: "📱 Виртуальная Халва оформляется за 5 минут онлайн. Кэшбэк до 10% и бесплатный выпуск.",
          upvoteCount: 42,
        },
      },
    }),
  ],
  [
    CREDIT_CARDS_BY_TARGET,
    (url) => ({
      "@context": "https://schema.org",
      "@type": "QAPage",
      mainEntity: {
        "@type": "Question",
        name: "Почему Халва лучше кредитной карты?",
        url,
        answerCount: 1,
        acceptedAnswer: {
          "@type": "Answer",
          text: "💸 Снятие наличных в рассрочку до 3 мес\n🆓 0 ₽ за выпуск и обслуживание\n💰 кэшбэк до 10%",
          upvoteCount: 60,
        },
      },
    }),
  ],
  [
    CREDIT_CARDS_BY_PERIOD,
    (url) => ({
      "@context": "https://schema.org",
      "@type": "QAPage",
      mainEntity: {
        "@type": "Question",
        name: "Почему карта Халва выгоднее обычной кредитки?",
        url,
        answerCount: 1,
        acceptedAnswer: {
          "@type": "Answer",
          text: "Халва даёт рассрочку до 10 месяцев без переплат, а обслуживание всегда бесплатно!",
          upvoteCount: 38,
        },
      },
    }),
  ],
  [
    CREDIT_CARDS_BY_SUM,
    (url) => ({
      "@context": "https://schema.org",
      "@type": "QAPage",
      mainEntity: {
        "@type": "Question",
        name: "Почему карта «Халва» лучше кредитной карты?",
        url,
        answerCount: 1,
        acceptedAnswer: {
          "@type": "Answer",
          text: "С Халвой можно снимать наличные в рассрочку на 3 месяца, не платить за обслуживание и получать кэшбэк за покупки.",
          upvoteCount: 45,
        },
      },
    }),
  ],
  [
    CREDIT_CARDS_IN_OTHERS_CITY,
    (url) => ({
      "@context": "https://schema.org",
      "@type": "QAPage",
      mainEntity: {
        "@type": "Question",
        name: "Чем карта Халва лучше кредитной карты?",
        url,
        answerCount: 1,
        acceptedAnswer: {
          "@type": "Answer",
          text: "🚘 Карту Халва доставят курьером бесплатно, а покупки можно оплачивать в рассрочку до 10 месяцев.",
          upvoteCount: 28,
        },
      },
    }),
  ],
])

export const typeQAPageCreditCard = (url: string) => {
  const iterator = map.entries()

  let data = iterator.next()

  while (data.value) {
    const [urls, fn] = data.value

    if (urls.includes(url)) {
      return JSON.stringify(fn(url))
    }

    data = iterator.next()
  }
  // Дефолтный вариант
  return JSON.stringify({
    "@context": "https://schema.org",
    "@type": "QAPage",
    mainEntity: {
      "@type": "Question",
      name: "Почему условия карты Халва выгоднее кредитной карты?",
      url,
      answerCount: 1,
      acceptedAnswer: {
        "@type": "Answer",
        text: "⏳ Рассрочка до 10 месяцев без процентов. 🆓 Не платите за выпуск и обслуживание карты — всё бесплатно!",
        upvoteCount: 55,
      },
    },
  })
}
